export const APP_SPACE_AUTH = 'app-space:auth';
export const APP_SPACE_MEMBERSHIP = 'app-space:membership';
